import { Loader2, TriangleAlert } from "lucide-react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogCancel, AlertDialogAction,
} from "@/components/ui/alert-dialog";

export const ConfirmDialog = ({ open, onOpenChange, title, description, confirmLabel = "Delete", onConfirm, busy = false }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="bg-card border-gray-800">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display flex items-center gap-2 text-white">
          <span className="h-8 w-8 rounded-lg bg-red-500/15 border border-red-500/30 flex items-center justify-center shrink-0">
            <TriangleAlert className="h-4 w-4 text-red-400" />
          </span>
          {title}
        </AlertDialogTitle>
        <AlertDialogDescription className="text-gray-400 pt-1">{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="confirm-cancel" className="bg-transparent border-gray-700 text-gray-300 hover:bg-gray-800 hover:text-white">Cancel</AlertDialogCancel>
        <AlertDialogAction data-testid="confirm-delete" onClick={onConfirm} disabled={busy} className="bg-red-500 hover:bg-red-600 text-white gap-2">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null} {confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default ConfirmDialog;
